import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_APP_GATEWAY_URL}/artwork-content/google/translate`;

export interface TranslateParams {
  content: string;
  language: 'en' | 'ja' | 'zh';
}

export const translate = async (params: TranslateParams) => {
  const res = await axiosInstance.post<BaseResponse<string>>(baseUrl, params);
  return res.data;
};
